import React, {useRef} from "react";
import {ReactComponent as ImageIcon} from "@assets/icons/image.svg";

interface ImageToolProps {
    onInsertImage: (file: File) => void;
}

const ImageButton: React.FC<ImageToolProps> = ({onInsertImage}) => {
    const inputRef = useRef<HTMLInputElement>(null);

    return (
        <>
            <input
                ref={inputRef}
                type="file"
                accept="image/*"
                className="fixed inset-0 w-[0px] h-[0px] opacity-0 cursor-pointer z-[-10]"
                onChange={(e) => {
                    const file = e.target.files?.[0];
                    if (file) onInsertImage(file);
                    e.target.value = "";
                }}
            />
            <button
                type="button"
                onClick={() => inputRef.current?.click()}
                className="px-2 w-10 h-10 hover:bg-on-surface/5 rounded-full flex items-center justify-center"
                title="Dodaj obraz"
            >
                <ImageIcon/>
            </button>
        </>
    );
};

export default ImageButton;
